module.exports = __webpack_public_path__ + "static/media/delivery.72237e69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bottomNavigation/delivery.svg
// module id = 2252
// module chunks = 0